import React from "react";

const Freelancing = () => {
    return (
        <div>
            <div>
                {/* Experience list */}
                <div className=" text-gray-500">
                    <div className="  mt-10">
                        <h3 className=" text-2xl md:text-3xl text-gray-400 font-bold">
                            {" "}
                            Freelancing ( Client from Ukraine )
                        </h3>
                        <div className=" flex flex-col gap-4 mt-4 ml-4">
                            <div>
                                <span className="font-bold text-lg text-gray-400">
                                    Project Description:
                                </span>{" "}
                                Developed a Small-Scale Service Marketplace for
                                Horsecare Professionals
                            </div>
                            <div className=" ">
                                <span className="font-bold text-lg text-gray-400">
                                    Location :
                                </span>{" "}
                                Remote
                            </div>
                            <div>
                                <span className="font-bold text-lg text-gray-400">
                                    Duration :
                                </span>{" "}
                                1 month
                            </div>
                            <div>
                                <span className="font-bold text-lg text-gray-400">
                                    Tech Stack :
                                </span>{" "}
                                <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-blue-400 border border-blue-400">
                                    React
                                </span>{" "}
                                <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-indigo-400 border border-indigo-400">
                                    TypeScript
                                </span>{" "}
                                <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-gray-400 border border-gray-500">
                                    Shadch_UI
                                </span>{" "}
                                <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-purple-400 border border-purple-400">
                                    Tailwind_css
                                </span>{" "}
                                <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-red-400 border border-red-400">
                                    Git
                                </span>{" "}
                                <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-green-400 border border-green-400">
                                    Supabase
                                </span>{" "}
                                <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-gray-300 border border-gray-300">
                                    Express_js
                                </span>{" "}
                                <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-pink-400 border border-pink-400">
                                    Stripe
                                </span>{" "}
                            </div>
                            <div>
                                <h4 className=" font-bold text-lg text-gray-400">
                                    Responsibilities and Achievements
                                </h4>
                                <p>
                                    <ul className=" list-disc p-5 pt-2">
                                        <li>
                                            Led the development of a horsecare
                                            service marketplace using
                                            TypeScript, React, and Supabase.{" "}
                                        </li>
                                        <li>
                                            Designed a responsive front-end with
                                            a landing page, search, and user
                                            order, emphasizing mobile-friendly
                                            and user-centric principles..{" "}
                                        </li>
                                        <li>
                                            Established back-end infrastructure
                                            with Supabase, creating models for
                                            users, services, and bookings.
                                            Integrated a Stripe payment API for
                                            enhanced functionality, ensuring
                                            secure transactions.{" "}
                                        </li>
                                        <li>
                                            Evaluation based on code quality,
                                            functionality, UI/UX design,
                                            problem-solving, and thorough
                                            documentation.
                                        </li>
                                    </ul>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                {/* Experience list */}
                <div className=" ">
                    <div className=" mt-10">
                        <h3 className=" text-3xl font-bold text-gray-400">
                            {" "}
                            Freelancing ( Client from Yemen )
                        </h3>
                        <div className=" flex flex-col gap-4 mt-4 ml-4">
                            <div>
                                <span className="font-bold text-lg text-gray-400">
                                    Project Description:
                                </span>{" "}
                                AI Chatbot with Langfuse analytics and OpenAI
                            </div>
                            <div className=" ">
                                <span className="font-bold text-lg text-gray-400">
                                    Location :
                                </span>{" "}
                                Remote
                            </div>
                            <div>
                                <span className="font-bold text-lg text-gray-400">
                                    Duration :
                                </span>{" "}
                                1 month
                            </div>
                            <div>
                                <span className="font-bold text-lg text-gray-400">
                                    Tech Stack :
                                </span>{" "}
                                <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-gray-400 border border-gray-500">
                                    Next_JS
                                </span>{" "}
                                <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-red-400 border border-red-400">
                                    LangFuse
                                </span>{" "}
                                <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-green-400 border border-green-400">
                                    Open_AI
                                </span>{" "}
                                <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-gray-300 border border-gray-300">
                                    Vectara
                                </span>{" "}
                                <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-pink-400 border border-pink-400">
                                    Express_Js
                                </span>{" "}
                                <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-yellow-400 border border-yellow-400">
                                    JavaScript
                                </span>{" "}
                                <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-purple-400 border border-purple-400">
                                    Tailwind_css
                                </span>{" "}
                                <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-red-400 border border-red-400">
                                    Git
                                </span>{" "}
                            </div>
                            <div>
                                <h4 className=" font-bold text-lg">
                                    Responsibilities and Achievements
                                </h4>
                                <p>
                                    <ul className=" list-disc p-5 pt-2">
                                        <li>
                                            Led the design and implementation of
                                            an AI chatbot using Next.js,
                                            Tailwind CSS, and Express.js..{" "}
                                        </li>
                                        <li>
                                            Integrated OpenAI API, Langfuse
                                            Analytics, and Vectara GenAI to
                                            enhance chatbot capabilities.{" "}
                                        </li>
                                        <li>
                                            Implemented a secure access
                                            verification process for user
                                            queries, ensuring data integrity.{" "}
                                        </li>
                                        <li>
                                            Managed communication with OpenAI
                                            API and Langfuse Analytics to
                                            enhance chatbot responses.
                                            Streamlined data flow to the user
                                            end, providing a responsive chatbot
                                            experience
                                        </li>
                                    </ul>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Freelancing;
